export default __webpack_public_path__ + "static/media/bigFfff2.e1a23f6d.png";